import { usePublicBoundlessConfigRetrieveSuspense } from "@boundless/bl-api-client/public/services"
import { FileX2Icon } from "lucide-react"

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

export function NoDocumentAccessCard() {
  const { data: boundlessConfig } = usePublicBoundlessConfigRetrieveSuspense()

  return (
    <Card>
      <CardHeader>
        <CardTitle>Business Documents</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col items-center gap-5 text-center">
        <p>
          Unfortunately this borrower has revoked access to their data room. If
          you have any questions please contact the Boundless support team at{" "}
          <a
            href={`mailto:${boundlessConfig.supportEmail}`}
            className="text-primary font-bold"
          >
            {boundlessConfig.supportEmail}
          </a>
        </p>
        <FileX2Icon className="text-muted h-14 w-14" />
      </CardContent>
    </Card>
  )
}
